package com.tovtalk.ui.components

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.tovtalk.ui.theme.TovTalkTheme

/**
 * Blue CTA button (M3). Uses brand color (Blue 600).
 */
@Composable
fun BluePrimaryButton(
    text: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
    loading: Boolean = false
) {
    TovTalkButton(
        text = text,
        onClick = onClick,
        modifier = modifier,
        variant = TovTalkButtonVariant.Primary,
        enabled = enabled,
        loading = loading,
        fullWidth = true
    )
}
